module.exports = __webpack_public_path__ + "docs/img/cloud-js-100.53d7041a.png";